module.exports = __webpack_public_path__ + "img/title_no.ff017fcf.svg";